// extracted by mini-css-extract-plugin
export default {"mark":"CellContent_mark__Qhdxh","checkbox":"CellContent_checkbox__wKmxw","desktop":"CellContent_desktop__gv9V-","link":"CellContent_link__KB1ud","icon":"CellContent_icon__Oi-vg"};